import { createAction } from "redux-actions";

import * as types from "./types";

export const initApp = createAction(types.INIT_APP);
